import { Component, OnInit, signal } from '@angular/core';
import { AuthenticationService } from '../../services/Authentication/authentication.service';
import { ActivatedRoute } from '@angular/router';
import { PermissionService } from '../../services/Authentication/permission.service';
import { environment } from '../../../../environments/environment';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-authentication',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './authentication.component.html',
  styleUrl: './authentication.component.scss',
})
export class AuthenticationComponent implements OnInit {
  PORTAL = `${environment.PORTAL}`;

  readonly isLoading = signal<boolean>(true);
  readonly errorMessage = signal<string | null>(null);

  constructor(
    private authService: AuthenticationService,
    private permissionService: PermissionService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      const authKey =
        params['auth-key'] ||
        params['authKey'] ||
        params['key'] ||
        params['token'] ||
        this.route.snapshot.queryParamMap.get('auth-key');

      if (authKey) {
        this.performLogin(authKey);
      } else if (this.authService.getAccessToken()) {
        this.permissionService.refreshPermissions();
        this.authService.homePage();
      } else {
        this.loginAsGuest();
      }
    });
  }

  private performLogin(authKey: string): void {
    this.isLoading.set(true);
    this.errorMessage.set(null);

    this.authService.login(authKey).subscribe({
      next: (isLoggedIn: boolean) => {
        if (isLoggedIn) {
          this.permissionService.refreshPermissions();
          this.authService.homePage();
        } else {
          this.loginAsGuest();
        }
      },
      error: (_error: any) => {
        this.loginAsGuest();
      },
    });
  }

  private loginAsGuest(): void {
    this.isLoading.set(true);
    this.errorMessage.set(null);

    this.authService.loginGuest().subscribe({
      next: (isLoggedIn: boolean) => {
        if (isLoggedIn) {
          this.permissionService.refreshPermissions();
          this.authService.homePage();
        } else {
          this.handleError('Guest login failed. Please try again.');
        }
      },
      error: (error: any) => {
        const msg =
          error?.error?.message ||
          error?.error?.errors?.[0] ||
          'Guest login failed. Please contact your system administrator.';
        this.handleError(msg);
      },
    });
  }

  private handleError(msg: string): void {
    this.isLoading.set(false);
    this.errorMessage.set(msg);
  }

  redirectToPortal(): void {
    window.location.href = this.PORTAL;
  }
}
